import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import Logo from "./Logo";
import { IGNITE_CONSULT_URL, PAPERFORM_URL } from "@/lib/leads";

const LINKEDIN_URL = "https://www.linkedin.com/company/the-hrconnect/";

export default function Footer() {
    return (
        <footer className="border-t border-border bg-surface" data-testid="site-footer">
            <div className="container-x py-16 md:py-20 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5 space-y-5">
                    <Logo />
                    <p className="body max-w-sm">
                        HR Connect is a talent and benefits advisory brand for
                        small and midsize businesses.
                    </p>
                    <div className="flex flex-col gap-3">
                        <a
                            href="mailto:info@thehrconnect.co"
                            data-testid="footer-email"
                            className="inline-block text-sm text-foreground hover:text-brand transition-colors underline underline-offset-4 decoration-border"
                        >
                            info@thehrconnect.co
                        </a>
                        <a
                            href={LINKEDIN_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-linkedin"
                            className="inline-flex items-center gap-2 text-sm text-foreground hover:text-brand transition-colors"
                            aria-label="The HR Connect on LinkedIn"
                        >
                            <Linkedin className="h-4 w-4" strokeWidth={1.75} />
                            <span className="underline underline-offset-4 decoration-border">
                                Follow us on LinkedIn
                            </span>
                        </a>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <p className="eyebrow mb-5">Explore</p>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/benefits/ignite-health" data-testid="footer-link-ignite" className="text-ink-soft hover:text-foreground">Ignite Health partner page</Link></li>
                        <li><Link to="/ny" data-testid="footer-link-ny" className="text-ink-soft hover:text-foreground">For New York employers</Link></li>
                        <li><Link to="/about" data-testid="footer-link-about" className="text-ink-soft hover:text-foreground">About HR Connect</Link></li>
                        <li><Link to="/contact" data-testid="footer-link-contact" className="text-ink-soft hover:text-foreground">Contact</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="eyebrow mb-5">Get started</p>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a
                                href={PAPERFORM_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-cta-proposal"
                                className="text-foreground hover:text-brand"
                            >
                                Get your free benefits assessment →
                            </a>
                        </li>
                        <li>
                            <a
                                href={IGNITE_CONSULT_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-cta-ignite"
                                className="text-ink-soft hover:text-foreground underline underline-offset-4 decoration-border"
                            >
                                Book directly with Ignite Health
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border">
                <div className="container-x py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-ink-soft">
                    <p>© {new Date().getFullYear()} HR Connect. Advisory services for growing employers.</p>
                    <p>Built for small and midsize businesses.</p>
                </div>
            </div>
        </footer>
    );
}
